module.exports = __webpack_public_path__ + "static/media/man-sitting-warehouse.d03f75d5.jpg";